// `.env.ts` is generated by the `npm run env` command
import { env } from './.env';
export const environment = {
  production: true,
  version: env.npm_package_version + '-uat',
  appVersion: require('../../package.json').version,
  apiUrl: (window as any).baseUrl + '/app',
  serverUrl: '/api',
  apiVersion: '/v1',
  defaultLanguage: 'en-CA',
  hmr: false,
  logs: false,
  reflecxRoutePrefix: 'composer', // admin, '', admin
  reportingRoutePrefix: 'insights', // reporting, reporting, ''
  defaultAppRoute: 'insights', // reporting, datasource, globaldashboard
  Apps: { ReflecxApp: true, ReportingApp: true },
  baseLine: false,
  cacheDb: 'MyApp',
  engineUrl: (window as any).baseUrl + '/responses/',

  libraryPath: '/library/',
  FilePath: '/Uploads/',
  directorySeparator: '/',
  fromEmailAddress: ['survey@epanelprogram.toyotaexperience.ca'],
  dateFormat: 'LLL dd, yyyy, hh:mm:ss aa',
  signalRConfigured: true,
  signalRUrl: (window as any).baseUrl + '/app/RealTimeNotificationHub',
  loaderStyle: 'main',
  printServerUrl: (window as any).baseUrl + '/print',
  crosstabApiUrl: 'https://sandbox.reflecx.io/crosstabs_api/',
  isPrintAllowed: true,
  defaultMarketLanguage: 'en-CA',
  NotificationSetting: {
    notificationSessionTimeoutMinutes: 30,
    notificationUpdateInterval: 30000,
  },
  login: {
    isDefaultEnabled: false,
    defaultRoute: '/login/:id',
    defaultRouteValue: 'utility',
  },
  whitelabelledDomains: [
    {
      domain: 'https://staging.ccacustomerserviceexperience.com',
      realm: 'staging-hca',
    },
    {
      domain: 'https://sandbox.ccacustomerserviceexperience.com',
      realm: 'staging-hca',
    },
    {
      domain: 'https://staging-survey.nissancustomervoice.com',
      realm: 'staging-nci',
    },
    {
      domain: 'https://uat.nissancustomervoice.com',
      realm: 'staging-nci',
    },
    {
      domain: 'https://sandbox.nissancustomervoice.com',
      realm: 'staging-nci',
    },
    {
      domain: 'https://keycloak-sandbox.reflecx.io',
      realm: 'sandbox-reflecx',
    },
    {
      domain: 'https://epanel-sandbox.reflecx.io',
      realm: 'sandbox-epanel',
    },
  ],
  epanelSsoUrl: 'https://epanel-sandbox.reflecx.io/portal',
};

//// keycloakAngularConfig Angular Client Configuration
export const keycloakAngularConfig = {
  authority: 'https://identity.reflecx.io',
  portalUrl: (window as any).baseUrl + '/portal',
  realm:
    environment.whitelabelledDomains.find((x) => x.domain === window.location.origin)?.realm != null &&
    environment.whitelabelledDomains.find((x) => x.domain === window.location.origin)?.realm != undefined
      ? environment.whitelabelledDomains.find((x) => x.domain === window.location.origin)?.realm
      : 'sandbox-reflecx',
  clientId: 'angular-client',
  redirectUri: window.location.href,
  silentCheckSsoRedirectUri: window.location.origin + '/portal/silent-check-sso.html',
  enableLogging: true,
  checkLoginIframe: false,
  clockSkew: 86400,
};

// IdentityServer Angular Client Configuration
export const identityServerAngularConfig = Object.assign({}, (window as any).bootstrapSettings);

// IdentityServer TCI SSO Configuration
export const identityServerTCIConfig = {
  authority: 'https://sandbox.reflecx.io/identity',
  client_id: 'tci.rop.client',
  scope: 'api1',
  secret: 'secret',
};

// // IdentityServer SSO Configuration
export const identityServerSSOConfig = {
  authority: (window as any).baseUrl + '/accounts',
  client_id: 'external.saml',
  redirect_uri: (window as any).baseUrl + '/portal/extcallback.html',
  response_type: 'code',
  scope: 'openid profile email api1 offline_access',
  post_logout_redirect_uri: (window as any).baseUrl + '/portal/ext-signout-callback',
  silent_redirect_uri: (window as any).baseUrl + '/portal/silent-callback.html',
  accessTokenExpiringNotificationTime: 300,
  automaticSilentRenew: true,
  clockSkew: 86400,
};

export const apiURL = 'https://inteliq.io/demoapi';
export const staticUrl = 'https://clearviewprodemo.com';
export const QNAAPIURL = 'http://172.21.3.198:8015/qa_service/';
export const pipelineData = {
  Comment_Type: 'social_media',
  TopNCategories: '3',
  ModelFilesPath: '/data/E_Drive/All_Models/cross_lingual_models',
  BatchSizetoProcess: '1000',
  ClientCode: 'Acura',
  IS_DEBUG: 'False',
  Client_Name_Masking: 'Toyota',
};
